module.exports = __webpack_public_path__ + "img/IMG_6070_FoamcoreMatted.02424de8.jpg";